export const hash = (obj) => {
  // https://ssojet.com/hashing/dhash-in-javascript-in-browser/
  const simple = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(16); // Return as hex string
  };
  const str = typeof obj === 'string' ? obj : JSON.stringify(obj || '');
  return simple(str);
};

// https://chatgpt.com/share/69dead1b-cd58-83e8-811e-512b58fd395d
export const prettyBytes = (bytes, opts = {}) => {
  if (bytes === 0) return '0 B';
  if (!Number.isFinite(bytes)) return String(bytes);

  const {
    base = 1024, // 1024 (binary) or 1000 (decimal)
    decimals = 2, // max decimal places
    minDecimals = 0, // minimum decimal places
  } = opts;

  const units = base === 1024 ? ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'] : ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB'];

  const sign = bytes < 0 ? '-' : '';
  const abs = Math.abs(bytes);

  const i = Math.min(Math.floor(Math.log(abs) / Math.log(base)), units.length - 1);

  const value = abs / Math.pow(base, i);

  const str = value.toFixed(decimals);
  const trimmed = decimals > minDecimals ? str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : str;

  return `${sign}${trimmed}${units[i]}`;
};

export const elapsedFromTimer = (timer) => {
  if (!timer?.scopes) {
    return;
  }

  const started = Math.min(...timer.scopes.map((it) => it.started));
  const finished = Math.max(...timer.scopes.map((it) => it.finished));
  return Math.max(finished - started, 0);
};

export const srid = (len = 6, prefix = '') => {
  const alpha = 'abcdefghijklmnopqrstuvwxyz0123456789'.split('');
  let id = '';
  for (let i = 0; i < len; i++) {
    id += alpha[Math.floor(Math.random() * alpha.length)];
  }

  // bullmq doesn't allow integer custom ID's, ensure at least one
  // alpha character
  const r = prefix + id;
  if (r.match(/^[0-9]+$/)) {
    return srid(len, prefix);
  } else {
    return r;
  }
};

export const formatUSD = (amount) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
